import { NativeNoteEditorEvent } from '../../types';
import { parseEventMessage } from '../parseEventMessage';

export function parseNativeNoteEditorEvent(
  message: string,
): NativeNoteEditorEvent {
  return (parseEventMessage(message) as unknown) as NativeNoteEditorEvent;
}
